import React from 'react';
import { CommonTriggerProps } from './types';
import Styled from './DropdownTrigger.styles';

export type CustomDropdownTriggerProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onSelect' | 'value'
> & {
  /** Opens dropdown on hover if true; currently only works for custom dropdown trigger */
  isHoverTrigger?: boolean;
  /** Element that will replace the normal input element */
  trigger: JSX.Element;
};

export const CustomDropdownTrigger = ({
  disabled,
  toggleDropdown,
  id,
  isHoverTrigger,
  handleKeyDown,
  expanded,
  trigger,
  ...rest
}: CustomDropdownTriggerProps & CommonTriggerProps): JSX.Element => {
  return (
    <Styled.InputSection
      isHoverTrigger={isHoverTrigger}
      onClick={(e) => !disabled && toggleDropdown(e)}
    >
      <Styled.Trigger
        disabled={disabled}
        id={id}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        data-expanded={expanded}
        {...rest}
      >
        {trigger}
      </Styled.Trigger>
    </Styled.InputSection>
  );
};
